// Keep Inbank's eligibility, disclosures and updates; simplify only split-payment copy.
export function splitPaymentSummary(text, totalCents) {
  const match = text.trim().match(/^Maksā ([36]) daļās bez pārmaksas/);
  if (!match) return null;
  const parts = Number(match[1]);
  const amounts = [...text.matchAll(/(\d+(?:[.,]\d{2}))\s*€/g)]
    .map(match => Math.round(Number(match[1].replace(',', '.')) * 100));
  if (parts === 3 && amounts.length === 3) {
    totalCents = amounts.reduce((sum, amount) => sum + amount, 0);
  }
  if (!Number.isSafeInteger(totalCents) || totalCents <= 0) return null;
  const monthly = (Math.round(totalCents / parts) / 100).toFixed(2);
  return { text: `Maksā ${parts} daļās bez pārmaksas: ${monthly} € mēnesī`, totalCents };
}

if (typeof customElements !== 'undefined' && !customElements.get('defset-inbank')) {
  customElements.define('defset-inbank', class extends HTMLElement {
    connectedCallback() {
      this.originals = new WeakMap();
      this.observer = new MutationObserver(() => this.update());
      this.update();
    }
    update() {
      this.observer.disconnect();
      const texts = [...this.querySelectorAll('.ib-calculator-item-content__text')];
      let total;
      // Derive the six-part amount from the provider's current three-payment total.
      // Never invent a total if the provider hasn't supplied one.
      for (const node of texts) {
        const prior = this.originals.get(node);
        const raw = prior?.display === node.textContent ? prior.raw : node.textContent;
        const summary = splitPaymentSummary(raw);
        if (summary) total = summary.totalCents;
      }
      for (const node of texts) {
        const prior = this.originals.get(node);
        const raw = prior?.display === node.textContent ? prior.raw : node.textContent;
        const summary = splitPaymentSummary(raw, total);
        if (!summary) continue;
        this.originals.set(node, {raw, display: summary.text});
        if (node.textContent !== summary.text) node.textContent = summary.text;
      }
      this.observer.observe(this, {childList: true, subtree: true, characterData: true});
    }
    disconnectedCallback() { this.observer?.disconnect(); }
  });
}
